import { render, staticRenderFns } from "./menuHeader.vue?vue&type=template&id=5b3bc648&scoped=true&"
import script from "./menuHeader.vue?vue&type=script&lang=js&"
export * from "./menuHeader.vue?vue&type=script&lang=js&"
import style0 from "./menuHeader.vue?vue&type=style&index=0&id=5b3bc648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bc648",
  null
  
)

export default component.exports